export default from './Footer';



// WEBPACK FOOTER //
// ./src/sharedComponents/Footer/index.js